import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Stack } from "@mui/material";
import { Clear, FilterAlt } from "@mui/icons-material";
import { listStoreCapacities } from "../../../../api_calls/loopCampaign";
import DisabledButton from "../../../../components/commonComponents/Buttons/DisabledButton";
import ActionButton, { LightGreyButton } from "../../../../components/commonComponents/Buttons/ActionButton";
import { SpaceBetweenStack } from "../../../../components/commonComponents/StyledComponents/styled";
import MultiSelect from "../../../../components/commonComponents/Selectors/MultiSelect";
import { deleteItems, updateStateData } from "../../../../Store/actions";
import store from "../../../../Store/store";
import AddressSearchFilter from "./AddressSearchFilter";
import { canViewStoreOwner } from "../../../../api_calls/userManagement";

const StoreCapacityFilter = ({ loopId }) => {
    const storeListDetails = useSelector((state) => state.userSelections);

    const [loopStoreNameFilter, setLoopStoreNameFilter] = React.useState([]);
    const [statusFilter, setStatusFilter] = React.useState([]);
    const [addressFilter, setAddressFilter] = React.useState([]);
    const [ownerFilter, setOwnerFilter] = React.useState([]);

    // Same rule as the Owner column in StoresList
    const showOwnerFilter = canViewStoreOwner();

    const dispatchAction = useDispatch();

    const saveStoreFilters = (e) => {
        e.preventDefault();
        if (
            statusFilter.length === 0 && loopStoreNameFilter.length === 0 && addressFilter.length === 0 && ownerFilter.length === 0
        ) {
            // toast("Please select filters before applying.", { type: "error" });
            clearfilters();
        } else {
            const filterKeywords = ["status_filter", "loop_store_filter", "address_filter", "owner_filter"];
            const selectedFilters = [statusFilter, loopStoreNameFilter, addressFilter, ownerFilter];
            let filterValues = {};
            /*
              There could be a simple straight forward way of adding values to the redux state.
              we have used map function here just to iterate through each record. Because otherwise,
              we get some error in browser console when we try to update a particular index in an array.
              However, when we use loop/map function then it doesn't show any error. 
              May be in future, we can figure out a better way to do this. But for time being, it's been
              implemented this way.
            */
            filterKeywords.map((keyword, index) => {
                filterValues = {
                    ...filterValues,
                    [keyword]: typeof selectedFilters[index] === "string" ? selectedFilters[index] : [...selectedFilters[index]],
                };
            });

            //save all selected filters to redux state (it will be accessed for generating powerpoint later)
            dispatchAction(
                updateStateData({
                    store_capacity_filters: filterValues,
                    store_capacity_filter_applied: true,
                })
            );

            // filter records according to the selection
            listStoreCapacities(loopId, 0, storeListDetails.store_capacity_pagination.pageSize);
        }
    };

    const clearfilters = () => {
        setStatusFilter([]);
        setLoopStoreNameFilter([]);
        setAddressFilter([]);
        setOwnerFilter([]);
        //reset clips listing
        dispatchAction(deleteItems(["store_capacity_filters", "store_capacity_filter_applied"]));
        listStoreCapacities(loopId, 0, storeListDetails.store_capacity_pagination.pageSize).then(info => {
            const selectedLoopData = typeof storeListDetails.new_loop_data !== "undefined" ? storeListDetails.new_loop_data : {};
            dispatchAction(
                updateStateData({
                    new_loop_data: {
                        ...selectedLoopData,
                        all_stores_selected: false,
                    },
                })
            );
        })
    };

    React.useEffect(() => {
        if (typeof storeListDetails.store_capacity_filters !== "undefined") {
            setLoopStoreNameFilter(storeListDetails.store_capacity_filters.loop_store_filter);
            setStatusFilter(storeListDetails.store_capacity_filters.status_filter);
        } else {
            setLoopStoreNameFilter([]);
            setStatusFilter([]);
        }
    }, [storeListDetails.store_capacity_filters, storeListDetails.store_capacity_list]);

    return (
        typeof storeListDetails.store_capacity_list !== "undefined" && (
            <>
                {/* ----------- filter row 1 -------- */}
                <Box>
                    <Stack direction={"row"} spacing={2}>
                        {/* ------- store name filters --------- */}
                        <MultiSelect
                            enableFullWidth={false}
                            label={"Store Name"}
                            options={typeof storeListDetails.capacity_store_names_list !== "undefined" ? storeListDetails.capacity_store_names_list : [{}]} // Example options, replace with actual data
                            usedFor="filter"
                            selectionCheck={(option, value) => option.label === value.label}
                            defaultVal={loopStoreNameFilter}
                            onChangeCall={(selectedOption) => {
                                setLoopStoreNameFilter(selectedOption);
                            }}
                        />

                        {/* --------- address filter ---------- */}
                        {/* <AddressSearchFilter
                            enableFullWidth={false}
                            label={"Address"}
                            options={typeof storeListDetails.capacity_address_names_list !== "undefined" && typeof storeListDetails.capacity_zip_code_list !== "undefined" && typeof storeListDetails.capacity_region_names_list !== "undefined" && typeof storeListDetails.capacity_city_names_list !== "undefined" ? [
                                ...storeListDetails.capacity_region_names_list.map(item => ({ ...item, type: 'region' })),
                                ...storeListDetails.capacity_address_names_list.map(item => ({ ...item, type: 'address' })),
                                ...storeListDetails.capacity_city_names_list.map(item => ({ ...item, type: 'city' })),
                                ...storeListDetails.capacity_zip_code_list.map(item => ({ ...item, type: 'zip' }))
                            ] :
                                [{}]
                            }
                            usedFor="filter"
                            selectionCheck={(option, value) => option.label === value.label}
                            defaultVal={addressFilter}
                            onChangeCall={(selectedOption) => {
                                setAddressFilter(selectedOption)
                            }}
                        /> */}
                        <Box width={1820}>
                            <MultiSelect
                                enableFullWidth={true}
                                label={"Location"}
                                options={typeof storeListDetails.capacity_address_names_list !== "undefined" && typeof storeListDetails.capacity_zip_code_list !== "undefined" && typeof storeListDetails.capacity_region_names_list !== "undefined" ? [
                                    ...storeListDetails.capacity_region_names_list.map(item => ({ ...item, type: 'region' })),
                                    ...storeListDetails.capacity_address_names_list.map(item => ({ ...item, type: 'address' })),
                                    ...storeListDetails.capacity_city_names_list.map(item => ({ ...item, type: 'city' })),
                                    ...storeListDetails.capacity_zip_code_list.map(item => ({ ...item, type: 'zip' }))
                                ] :
                                    [{}]
                                }
                                usedFor="filter"
                                selectionCheck={(option, value) => option.label === value.label}
                                defaultVal={addressFilter}
                                onChangeCall={(selectedOption) => {
                                    setAddressFilter(selectedOption)

                                }}
                            />
                        </Box>
                        {/* ------ owner name filter --------- */}
                        {
                            showOwnerFilter && (
                                <MultiSelect
                                    enableFullWidth={false}
                                    label={"Owner"}
                                    options={typeof storeListDetails.capacity_owner_names_list !== "undefined" ? storeListDetails.capacity_owner_names_list : [{}]} // Example options, replace with actual data
                                    usedFor="filter"
                                    selectionCheck={(option, value) => option.id === value.id}
                                    defaultVal={ownerFilter} // Default value, can be adjusted
                                    onChangeCall={(selectedOption) => {
                                        setOwnerFilter(selectedOption);
                                    }}
                                />
                            )
                        }

                        {/* ------------ store status filter ------------- */}
                        <MultiSelect
                            label={"Status"}
                            enableFullWidth={false}
                            disableSearch={true}
                            options={[{ label: "Available", value: true }, { label: "Unavailable", value: false }]}
                            usedFor="filter"
                            selectionCheck={(option, value) => option.label === value.label}
                            defaultVal={statusFilter} // Default value, can be adjusted
                            onChangeCall={(selectedOption) => {
                                setStatusFilter(selectedOption);
                            }}
                        />


                        <SpaceBetweenStack
                            direction={"row"}
                            spacing={2}
                            width={"100%"}
                            justifyContent={"space-between"}
                            display={"flex"}
                        >
                            <Stack direction={"row"} spacing={2}>
                                {/* --------- apply filter button ------- */}
                                {
                                    statusFilter.length === 0 && loopStoreNameFilter.length === 0 && addressFilter.length === 0 && ownerFilter.length === 0 ? (
                                        <DisabledButton
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                            label={"Apply"}
                                            icon={<FilterAlt />}
                                        />
                                    ) : (
                                        <ActionButton onClick={saveStoreFilters} label={"Apply"} icon={<FilterAlt />} />

                                    )
                                }
                                {/* ----- clear filter button ------ */}
                                {
                                    typeof storeListDetails.store_capacity_filter_applied !== "undefined" &&
                                        storeListDetails.store_capacity_filter_applied === true ? (
                                        <LightGreyButton
                                            onClick={(e) => {
                                                e.preventDefault();
                                                clearfilters();
                                            }}
                                            label={"Clear"}
                                            icon={<Clear />}
                                        />
                                    ) : (
                                        <DisabledButton
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                            label={"Clear"}
                                            icon={<Clear />}
                                        />
                                    )
                                }

                            </Stack>
                            {/* ------ overview should be hidden for brand user ----- */}
                            {/* <ActionButton
                                onClick={(e) => {
                                    // e.preventDefault();

                                }}
                                label={"Select all Available"}
                            /> */}
                        </SpaceBetweenStack>
                    </Stack>
                    <Box height={20} />
                </Box>
            </>
        )
    );
};

export default StoreCapacityFilter;
